// extracted by mini-css-extract-plugin
export var brand = "_1b-9";
export var button = "_1b-0";
export var chevron = "_1b-v";
export var chevronButton = "_1b-w";
export var content = "_1b-n";
export var danger = "_1b-g";
export var dangerOutlined = "_1b-h";
export var dark = "_1b-l";
export var darkTheme = "_1b-c";
export var extraSmall = "_1b-4";
export var fullWidth = "_1b-8";
export var ghost = "_1b-d";
export var gray = "_1b-t";
export var icon = "_1b-p";
export var iconButton = "_1b-s";
export var iconButtonBorder = "_1b-x";
export var iconButtonBorderDark = "_1b-y";
export var iconButtonBorderLight = "_1b-z";
export var iconLeft = "_1b-q";
export var iconRight = "_1b-r";
export var large = "_1b-1";
export var light = "_1b-m";
export var medium = "_1b-2";
export var micro = "_1b-5";
export var nano = "_1b-7";
export var outlined = "_1b-k";
export var pending = "_1b-a";
export var primary = "_1b-i";
export var shadow = "_1b-o";
export var small = "_1b-3";
export var solidLight = "_1b-e";
export var solidLightBrand = "_1b-f";
export var spinner = "_1b-u";
export var transparent = "_1b-j";
export var warning = "_1b-b";
export var wideNano = "_1b-6";